/**
 * @voltxampere/ui — Antenna placeholder (Sprint 45-3, placeholder)
 *
 * PLACEHOLDER. Generic RF antenna — radiation pattern + polarization
 * + impedance matching Sprint 47+ engine extension #4 ile aktif.
 * Şu anki davranış `wire-node` passthrough (antenna terminal'i
 * şematik üzerinde sadece ipucu).
 *
 * Reference: Generic RF antenna — quarter-wave whip, dipole,
 * patch, helical. Tipik 50 Ω input impedance, gain 0-20 dBi.
 * AM/FM receiver, GPS, WiFi, cellular, Bluetooth, NRF24 module.
 *
 * Engine zero-diff invariant honored — canonical `wire-node`
 * engine type via schemaType (passthrough — engine'de davranış
 * yok, sadece visual ipucu).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { node } from "../node.js";
export const rfAntenna = {
    id: "rf-antenna",
    nameTr: "RF Antenna (generic, placeholder)",
    nameEn: "RF Antenna (generic, placeholder)",
    shortcut: "N",
    category: "connector",
    viewBox: node.viewBox,
    terminals: node.terminals,
    defaultLabel: "ANT",
    defaultValue: "ANT",
    schemaType: "wire-node",
    defaultParams: {},
    renderSVG: () => node.renderSVG(),
};
//# sourceMappingURL=rf-antenna.js.map